import axios from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';
const baseApiUrl = 'api/noti';

export default class NotificationService {
  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public setSeen(id: number): void {
    axios.post(`${baseApiUrl}Seen/${id}`);
  }

  public setSeenAll(): void {
    axios.post(`${baseApiUrl}SeenAll`);
  }

  public retrieve(req?: any): Promise<any> {
    return axios.get(`${baseApiUrl}?${buildPaginationQueryOpts(req)}`);
  }

  public retrieveNew(): Promise<any> {
    return axios.get(`${baseApiUrl}New`);
  }

  public countNew(): Promise<any> {
    return axios.get(`${baseApiUrl}Count`);
  }
}
